import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import {
  Button,
  IconExternalLink,
  IconSearch,
  Input,
} from 'takeat-design-system-ui-kit';
import {
  Card,
  CategoriesContainer,
  Container,
  ContainerButtons,
  Header,
  SearchLink,
  Title,
} from './styles';
import { useAuth } from '~/context/AuthContext';

const SearchPage = (props) => {
  const { menuItems } = props;
  const pageItems = menuItems
    .filter(
      (category) =>
        category.displayType !== 'sidebar' && category.condition !== false
    )
    .map((category) => {
      return {
        ...category,
        subitems: category.subitems.filter(
          (subitem) =>
            subitem.displayType !== 'sidebar' && subitem.condition !== false
        ),
      };
    });
  const [filter, setFilter] = useState('');

  const filteredItems = pageItems
    .map((category) => {
      if (category.text.toLowerCase().includes(filter.toLowerCase())) {
        return category;
      }

      const filteredSubitems = category.subitems.filter((subitem) =>
        subitem.text.toLowerCase().includes(filter.toLowerCase())
      );

      if (filteredSubitems.length > 0) {
        return {
          ...category,
          subitems: filteredSubitems,
        };
      }

      return null;
    })
    .filter((item) => item !== null);

  const { user } = useAuth();
  const acessAdmin = user.user_role === 'Administrador';

  const handleSearchEnter = (e) => {
    if (e.key === 'Enter') {
      const firstItem = document.getElementById('menu-item-0');
      if (firstItem) {
        firstItem.click();
      }
    }
  };

  return (
    <Container>
      <Header>
        <div>
          <Title>Ver tudo</Title>
        </div>
      </Header>

      <ContainerButtons>
        <Input
          style={{ maxWidth: 300 }}
          iconLeft={<IconSearch />}
          placeholder="Buscar"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          onKeyDown={handleSearchEnter}
          autoFocus
        />

        {acessAdmin && (
          <Button
            children="Área do Gestor"
            style={{ width: 185 }}
            icon={<IconExternalLink />}
            onClick={() => {
              window.open('https://gestor.takeat.app/login');
            }}
          />
        )}
      </ContainerButtons>

      <CategoriesContainer layout="position">
        <AnimatePresence>
          {filteredItems.length === 0 ? (
            <span>Nenhum item encontrado</span>
          ) : (
            filteredItems.map((category) => {
              return (
                <Card layout="position" key={category.text}>
                  <h1>{category.text}</h1>
                  {category.subitems.map((subitem, idx) => {
                    return (
                      <SearchLink
                        id={`menu-item-${idx}`}
                        to={category.path + subitem.path}
                      >
                        {subitem.text}
                      </SearchLink>
                    );
                  })}
                </Card>
              );
            })
          )}
        </AnimatePresence>
      </CategoriesContainer>
    </Container>
  );
};

export default SearchPage;
